import React from 'react'
import { Box } from '@mui/material'

import { PageContentLayout } from '@layouts/PageContentLayout'
import { AppLoader } from '@components/AppLoader'
import { TimeLineGrid } from '@components/TimeLineGrid'
import { useConfig } from '@components/TimeLineGrid/hooks'

import { FLEXIBLE } from '@constants'
import { ApiRestrictionData } from '@types'

export const TimeLineGridPage = () => {
  const {
    config,
    isLoadingSearchAssistantConfig,
    searchAssistantConfig,
    isLoadingObjectYInitialRestrictions,
    isLoadingObjectXInitialRestrictions,
    objectXInitialRestrictions,
    objectYInitialRestrictions,
  } = useConfig()

  return (
    <Box sx={FLEXIBLE}>
      <PageContentLayout sx={FLEXIBLE}>
        {!config ||
        isLoadingSearchAssistantConfig ||
        isLoadingObjectXInitialRestrictions ||
        isLoadingObjectYInitialRestrictions ? (
          <AppLoader />
        ) : (
          <TimeLineGrid
            config={config}
            objectXInitialRestrictions={objectXInitialRestrictions as ApiRestrictionData}
            objectYInitialRestrictions={objectYInitialRestrictions as ApiRestrictionData}
            searchAssistantConfig={searchAssistantConfig}
          />
        )}
      </PageContentLayout>
    </Box>
  )
}
